import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageContainer } from "@/layout/PageContainer";
import { LoadingState, EmptyState } from "@/ui/feedback/states";
import { Button } from "@/ui/Button";
import { useTeamMember } from "./team.hooks";
import { MemberProfileView } from "./MemberProfileView";

export function TeamProfilePage() {
  const { t } = useTranslation();
  const { memberId } = useParams();
  const navigate = useNavigate();
  const { member, isLoading } = useTeamMember(memberId);

  if (isLoading) {
    return (
      <PageContainer>
        <LoadingState rows={6} />
      </PageContainer>
    );
  }

  if (!member) {
    return (
      <PageContainer>
        <EmptyState
          title={t("team.profileNotFound")}
          action={<Button size="sm" onClick={() => navigate("/team")}>{t("team.backToTeam")}</Button>}
        />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <MemberProfileView member={member} tasks={member.assignedTasks ?? []} onBack={() => navigate("/team")} />
    </PageContainer>
  );
}
